import i18n from 'i18next';
import {Button, Dropdown, DropdownItem} from 'platform/components';
import {Box, HStack, Show} from 'platform/foundation';

import {suffixTestId, type TestIdProps} from 'shared/web';

import type {BulkAction} from '../../types/api/bulkOperations';
import type {BulkOperationActionDefinitions} from '../../types/BulkOperationActionDefinition';
import {getBulkOperationActionDefinition} from '../../utils/getBulkOperationActionDefinition';

const QUICK_ACTION_LIMIT = 3;

type BulkOperationActionsToolbarProps = TestIdProps & {
  actions: BulkAction[];
  actionsDefinition: BulkOperationActionDefinitions;
  isDisabled: boolean;
  onOpenAction: (action: BulkAction) => void;
};

export function BulkOperationActionsToolbar(props: BulkOperationActionsToolbarProps) {
  const standardActions = props.actions.filter(
    (action) =>
      getBulkOperationActionDefinition(action.actionCode, props.actionsDefinition).variant !==
      'danger'
  );
  const quickActions = standardActions.slice(0, QUICK_ACTION_LIMIT);
  const overflowActions = props.actions.filter((action) => !quickActions.includes(action));

  return (
    <Box flexGrow={1}>
      <HStack spacing={2} justify="flex-end" wrap>
        {quickActions.map((action) => (
          <Button
            key={action.actionCode}
            title={
              getBulkOperationActionDefinition(action.actionCode, props.actionsDefinition).title
            }
            variant="secondary"
            isDisabled={props.isDisabled}
            onClick={() => props.onOpenAction(action)}
            data-testid={suffixTestId(`bulkOperation-${action.actionCode}`, props)}
          />
        ))}
        <Show when={overflowActions.length > 0}>
          <Dropdown
            dropdownControl={
              <Button
                title={i18n.t('general.labels.more')}
                rightIcon="navigation/expand_more"
                isDisabled={props.isDisabled}
                data-testid={suffixTestId('bulkOperations', props)}
              />
            }
            data-testid={suffixTestId('bulkOperationsMenu', props)}
          >
            {overflowActions.map((action) => (
              <DropdownItem
                key={action.actionCode}
                label={
                  getBulkOperationActionDefinition(action.actionCode, props.actionsDefinition).title
                }
                onClick={() => props.onOpenAction(action)}
                data-testid={suffixTestId(`bulkOperation-${action.actionCode}`, props)}
              />
            ))}
          </Dropdown>
        </Show>
      </HStack>
    </Box>
  );
}
